import { render, staticRenderFns } from "./four04.vue?vue&type=template&id=c098a1fa&scoped=true&"
import script from "./four04.vue?vue&type=script&lang=ts&"
export * from "./four04.vue?vue&type=script&lang=ts&"
import style0 from "./four04.vue?vue&type=style&index=0&id=c098a1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c098a1fa",
  null
  
)

export default component.exports